import api from '../../api/activity'
import * as types from '../mutation-types'
import Dialog from '../../plugins/dialog.js'

const state = {
  provinceList: [],
  cityList: []
}

const getters = {
  provinceList: state => state.provinceList,
  cityList: state => state.cityList
}

const mutations = {
  [types.RECEIVE_PROVINCE_LIST] (state, {provinceList}) {
    state.provinceList = provinceList
  },
  [types.RECEIVE_PROVINCE_CITY_LIST] (state, {cityList}) {
    state.cityList = cityList
  },
  [types.CLEARE_CITY_LIST] (state) {
    state.cityList = []
  }
}

const actions = {
  getProvinceList ({state, getters, commit}) {
    return api.getProvinceList().then(response => {
      if (!response) {
        return
      }

      if (response.data.returnCode === 0) {
        commit(types.RECEIVE_PROVINCE_LIST, {provinceList: response.data.result})
      } else {
        Dialog.toast({title: response.data.message})
      }
    })
  },
  getProvinceCityList ({state, getters, commit}, {provinceId}) {
    commit(types.CLEARE_CITY_LIST)
    return api.getProvinceCityList(provinceId).then(response => {
      if (!response) {
        return
      }

      if (response.data.returnCode === 0) {
        commit(types.RECEIVE_PROVINCE_CITY_LIST, {cityList: response.data.result.citys})
      } else {
        Dialog.toast({title: response.data.message})
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/city.js